import ProductLink from '@components/common/ProductLink';
import useBreakpoint from '@utils/useBreakpoint';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ColorSwatch from './ColorSwatch';
import ProductSelectionColorRadioLinks from './ProductSelectionColorRadioLinks';
const ProductColours = (props) => {
    const { t } = useTranslation();
    const [swatchLenght, setSwatchLength] = useState(0);
    const noPDPLink = window.tileColorSwatch;
    const currentBreakpoint = useBreakpoint();
    const hiddenColours = props.variationValues.length - swatchLenght;
    useEffect(() => {
        //@ts-ignore disable-next-line
        if (currentBreakpoint >= window.mqObj.lg) {
            setSwatchLength(6);
        }
        else {
            setSwatchLength(4);
        }
    }, [currentBreakpoint]);
    const colorName = (variation) => {
        return (React.createElement("span", { "aria-hidden": "true", className: classNames('selector__menu__item__label', { 'has-hidden-colors': hiddenColours >= 1 }) }, variation.displayValue));
    };
    return (React.createElement("div", { className: classNames('selector-color-link', props.className) }, props.compressColorSwatch && props.variationValues.length >= 5 ? (React.createElement("div", { className: "selector__menu inverted" },
        props.variationValues.map((variation, i) => {
            if (i <= 4) {
                return (React.createElement("div", { key: variation.id },
                    React.createElement(ProductLink, { product: Object.assign(Object.assign({}, props.product), { id: variation.productId, route: variation.route, productUrl: variation.productUrl }), ariaLabel: props.product.productName + ' ' + variation.displayValue, className: classNames('selector__menu__item', variation.value == props.currentId && 'selected'), originalUuid: props.originalUuid },
                        React.createElement(ColorSwatch, { variation: variation }))));
            }
        }),
        React.createElement(ProductLink, { product: props.product, ariaLabel: props.product.productName, originalUuid: props.originalUuid },
            React.createElement("span", { className: "selector__more-colors" },
                "+ ",
                props.variationValues.length - 5,
                " ",
                t('label.colors'))))) : noPDPLink ? (React.createElement(ProductSelectionColorRadioLinks, Object.assign({}, props, { swatchLenght: swatchLenght }))) : (React.createElement("div", { className: "selector__menu inverted" }, props.variationValues.map((variation, index) => (React.createElement("div", { key: variation.id }, index < swatchLenght ? (React.createElement(ProductLink, { product: Object.assign(Object.assign({}, props.product), { id: variation.productId, route: variation.route, productUrl: variation.productUrl }), ariaLabel: props.product.productName + ' ' + variation.displayValue, className: classNames('selector__menu__item', variation.value == props.currentId && 'selected', (props.product.availability.isOutOfStock || variation.notShoppable) && 'is-disabled'), originalUuid: props.originalUuid },
        props.showColorName && colorName(variation),
        React.createElement(ColorSwatch, { variation: variation }))) : (React.createElement(React.Fragment, null, index + 1 == props.variationValues.length && React.createElement("div", { "aria-label": t('label.colorsa11y') },
        "+",
        hiddenColours))))))))));
};
ProductColours.defaultProps = {
    variationValues: [],
};
export default ProductColours;
